import Sections from "../components/Sections";
import { StoreState } from "../types";
import { connect } from "react-redux";
import {
  CBStructureFilterOptions,
  CBFinancialFilterOptions,
  SIStructureFilterOptions,
  SIFinancialFilterOptions,
} from "../../Historical/refdata/FieldSelectionOptions";

export function mapStateToProps({ query, columns }: StoreState.All) {
  const selectedReport = query.filters.selectedReport;

  const filterOptions:any = {
    "CBS": CBStructureFilterOptions,
    "CBF": CBFinancialFilterOptions,
    "SIS": SIStructureFilterOptions,
    "SIF": SIFinancialFilterOptions,
  };
  
  return {
    displayFields: query.displayFields,
    columns: columns,
    filterOptions: filterOptions[selectedReport],
  };
}

export default connect(mapStateToProps)(Sections);
